/* ROLES */
export const GET_GUESTS = "GET_GUESTS"
export const GET_GUESTS_SUCCESS = "GET_GUESTS_SUCCESS"
export const GET_GUESTS_FAIL = "GET_GUESTS_FAIL"

/* ROLES DETAIL*/
export const GET_GUEST_DETAIL = "GET_GUEST_DETAIL"
export const GET_GUEST_DETAIL_SUCCESS = "GET_GUEST_DETAIL_SUCCESS"
export const GET_GUEST_DETAIL_FAIL = "GET_GUEST_DETAIL_FAIL"

/**
 * ADD ROLE
 */
export const ADD_NEW_GUEST = "ADD_NEW_GUEST"
export const ADD_GUEST_SUCCESS = "ADD_GUEST_SUCCESS"
export const ADD_GUEST_FAIL = "ADD_GUEST_FAIL"

/**
 * EDIT ROLE
 */
export const UPDATE_GUEST = "UPDATE_GUEST"
export const UPDATE_GUEST_SUCCESS = "UPDATE_GUEST_SUCCESS"
export const UPDATE_GUEST_FAIL = "UPDATE_GUEST_FAIL"

/**
 * Delete user
 */
export const DELETE_GUEST = "DELETE_GUEST"
export const DELETE_GUEST_SUCCESS = "DELETE_GUEST_SUCCESS"
export const DELETE_GUEST_FAIL = "DELETE_GUEST_FAIL"

/**
 * CLEAR MESSAGE AND ERROR OBJECT
 */
export const CLEAR_MESSAGE = "CLEAR_MESSAGE"

/**
 * EDIT GUEST APPROVED ACCESS
 */
export const UPDATE_GUEST_ACCESS = "UPDATE_GUEST_ACCESS"
export const UPDATE_GUEST_ACCESS_SUCCESS = "UPDATE_GUEST_ACCESS_SUCCESS"
export const UPDATE_GUEST_ACCESS_FAIL = "UPDATE_GUEST_ACCESS_FAIL"

/**
 * Export GUEST for PMS
 */
 export const GET_EXPORT_GUEST = "GET_EXPORT_GUEST"
 export const GET_EXPORT_GUEST_SUCCESS = "GET_EXPORT_GUEST_SUCCESS"
 export const GET_EXPORTED_GUEST_FAIL = "GET_EXPORTED_GUEST_FAIL"
 export const RESET_EXPORT_DATA = "RESET_EXPORT_DATA"

 /**
  * Export Guest Complimentary Access.
  */
 export const GUEST_COMPLIMENTARY_ACCESS_REQUEST = "GUEST_COMPLIMENTARY_ACCESS_REQUEST";
 export const GUEST_COMPLIMENTARY_ACCESS_GRANT = "GUEST_COMPLIMENTARY_ACCESS_GRANT";
 export const GUEST_COMPLIMENTARY_ACCESS_REQUEST_SUCCESS = "GUEST_COMPLIMENTARY_ACCESS_REQUEST_SUCCESS";
 export const GUEST_COMPLIMENTARY_ACCESS_REQUEST_FAIL = "GUEST_COMPLIMENTARY_ACCESS_REQUEST_FAIL";
 export const GUEST_COMPLIMENTARY_ACCESS_GRANT_SUCCESS = "GUEST_COMPLIMENTARY_ACCESS_GRANT_SUCCESS";
 export const GUEST_COMPLIMENTARY_ACCESS_GRANT_FAIL = "GUEST_COMPLIMENTARY_ACCESS_GRANT_FAIL";
